<template>
  <span>
    <ed-button 
      class="btn btn-actionbar" 
      @click="getComments"
      name='comments'>
      Comments &amp; Attachments
    </ed-button>
    <ed-panel :show="showComments" title="Comments &amp; Attachments" @close="showComments=false" name='comments_panel'>
      <div class="content" slot="body">
        <ed-form :submit-visible="false">
          <div class="row">
            <div class="col-md-12">
              <hr />
              <div class="comments-section">

                <!-- Comments list -->
                <div class="comment-item"
                  v-for="item in comments"
                  :key="item.CommentId"
                >
                  <div class="comment-image-placeholder pull-left">
                    <div v-if="!item.LogoPath"
                      class="user-initials"
                    >
                      {{ item.UserInitials }}
                    </div>
                    <img v-else
                        class="user-avatar"
                        :src="userAvatar(item)"
                        alt="Profile Picture"
                    />
                  </div>

                  <div class="col-md-10">
                    <label>{{ item.UserFullName }}</label>
                    <label class="info pull-right">{{ item.CreatedDateFormatted }}</label>

                    <div v-if="item.Comment !== null && item.Comment.length" class="comment-text">{{ item.Comment }}</div>

                    <ed-upload :value='getFiles(item.SavedFiles)' no-button />
                  </div>

                  <br />
                  <hr class="clear" />
                </div>
              </div>

              <!-- Attach file to comment -->
              <div>
                <div class="section-title">Add Comment</div>
                <ed-upload
                  :class='{loading: !uploadFinished}'
                  field-label='Attach File'
                  button-label='Browse'
                  v-model='uploadedAttachments'
                  readonly
                  :multiple='true'
                  :postAction='api.env + api.$.upload.uploadCommnetFile'
                  :uploadAuto='true'
                  :data='uploadData'
                  @input='createAttachments'
                  :error='attachmentsMissing'
                  helptipBody='Choose at least one attachment'
                  :showHelptipIcon='false'
                  helptipHeader=''
                  name='comments_upload'
                ></ed-upload>
                <ed-textarea 
                  placeholder="Comment..." 
                  v-model="comment" 
                  :error="displayCommentError"
                  :rows="5" 
                  @input="commentChanged"
                  name='comments_textarea'>
                </ed-textarea>
              </div>

            </div>
          </div>
        </ed-form>
      </div>
      <div class="buttons" slot="footer">
        <ed-button 
          @click="saveComment" 
          :disabled='!uploadFinished' 
          class="pull-left"
          name='save_comments'>Submit</ed-button>
      </div>
    </ed-panel>
  </span>
</template>

<script>
  /* eslint spec-file: 0 */

  import Api from '../api'
  let api = new Api()

  export default {
    props: {
      invoiceKey: [Number, String],
      paymentInvoiceId: Number,
      programId: Number,
      userToken: String
    },

    data() {
      return {
        showComments: false,
        uploadedAttachments: [],
        attachmentsToSave: [],
        comments: [],
        comment: '',
        attachmentsMissing: false,
        uploadFinished: true,
        displayCommentError: false
      }
    },

    computed: {
      uploadData() {
        return {
          token: this.userToken
        }
      }
    },

    methods: {
      userAvatar(item) {
        return `${item.LogoPath}?v=${Math.random().toString(36).substring(2, 15)}`
      },

      getFiles(attachments) {
        return attachments
          ? attachments.map(attachment => ({
            name: attachment.AttachmentName,
            file: attachment.AttachmentFile,
            type: attachment.AttachmentType,
            size: attachment.AttachmentSize,
            path: this.getFilePath(attachment)
          }))
          : []
      },

      getFilePath(file) {
        return this.api.$.privateResources + 'MediaFiles/' + (file.AttachmentPath || '') + (file.AttachmentFile || '')
      },

      createAttachments(e) {
        let completedFiles = e.filter(item => item.success)

        if (completedFiles.length >= 1) {
          this.attachmentsMissing = false
        }

        if (completedFiles.length === e.length) {
          this.uploadFinished = true

          this.attachmentsToSave = e.map(item => {
            let itemResponse = item.response ? JSON.parse(item.response) : ''
            if (itemResponse.uploadError) {
              this.errorMessages.push('File "' + item.name + '": ' + itemResponse.uploadError)
            } else {
              return {
                AttachmentName: item.name,
                AttachmentSize: item.size,
                AttachmentFile: itemResponse ? itemResponse.file : (item.file || ''),
                AttachmentID: item.fileId || 0,
                AttachmentPath: itemResponse ? itemResponse.path : ''
              }
            }
          })

          // this.showUploadError = this.errorMessages.length > 0

          this.uploadedAttachments = this.uploadedAttachments.filter(item => item.response
            ? JSON.parse(item.response).success
            : item.success)
        } else {
          this.uploadFinished = false
        }
      },

      getComments() {
        this.showComments = !this.showComments
        if (this.showComments) {
          this.reset()

          this.doGetComments()
        }
      },

      doGetComments() {
        let invoiceKey = this.invoiceKey
        let paymentInvoiceId = this.paymentInvoiceId

        return this.api
          .get(api.GetComments(), { params: {
            invoiceKey: invoiceKey,
            paymentInvoiceId: paymentInvoiceId
          }})
          .then(e => {
            this.comments = e.data
          })
      },

      reset() {
        this.comment = ''
        this.uploadedAttachments = []
      },

      commentChanged() {
        this.displayCommentError = false
      },

      validateComment() {
        let isValid = (this.comment && this.comment.trim() !== '') ||
          this.uploadedAttachments.length > 0
        this.displayCommentError = !isValid
        return isValid
      },

      saveComment() {
        if (this.validateComment()) {
          let item = {
            InvoiceKey: this.invoiceKey,
            PaymentInvoiceId: this.paymentInvoiceId,
            ProgramId: this.programId,
            Comment: this.comment,
            Files: this.attachmentsToSave,
            FromPage: 'PaymentInvoice'
          }
          this.comments.push(item)

          this.api
            .post(api.SaveComments(), {
              item
            })
            .then(e => {
              this.reset()
              this.doGetComments()
            })
        }
      }
    }
  }

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

@mixin info {
  @include theme {
  color: v(background);
  }
  font-size: $font-size-small;
  font-weight: $font-weight-default;
  line-height: $font-size-xxlarge;
}

@mixin avatar {
  @include theme {
  background-color: v(background);
  }
  border-radius: 50%;
  margin-right: 5px;

  display: inline-block;
  text-align: center;
  width: 60px;
  height: 60px;
  line-height: 58px;
  vertical-align: middle;
}

.user-avatar {
  @include avatar;
}

.user-initials {
  @include avatar;
  font-size: 30px;
  @include theme {
  color: v(canvas);
  }
  text-transform: uppercase;
}

.info {
  @include info;
}

.comment-text {
  width: 100%;
  white-space: pre-wrap;
  font-size: 0.85em;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/I2P/components/comments.vue